import { useEffect, useRef, useState } from "react"

/* 要素が画面外にある場合は children を描画しないようにするコンポーネント */
export default function IntersectionObservedView ({ children, ...option }) {
  const wrapperRef = useRef(null)
  const [isVisible, setIsVisible] = useState(false)

  useEffect(() => {
    const wrapper = wrapperRef.current;

    const observer = new IntersectionObserver((entries) => {
      setIsVisible(entries.some((entry) => entry.isIntersecting))
    }, {...option})

    observer.observe(wrapper)

    return () => {
      observer.unobserve(wrapper)
    }
  }, [])

  return <div ref={wrapperRef}>{isVisible ? children : null}</div>
}